module.exports = __webpack_public_path__ + "static/img/event2.1854bda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my-irish-date/event2.png
// module id = s133
// module chunks = 0